import Vue from 'vue';
import VueRouter from 'vue-router';

import {APP_TONS} from '../config/constanst.config';

// import Home from '../views/Home.vue';
import Login from '../views/Login';
import Main from '../views/Main';

import Dashboard from '../views/Dashboard';
import CrewTONS from '../views/tons/CrewTONS';
import CrewTonIndex from '../views/tons/sub/TonIndex';
import CrewTonView from '../views/tons/sub/TonView';

import ChangePassword from '../views/change-pass/ChangePassword';

import Settings from '../views/settings/Settings';
import Vessel from '../views/settings/matrix/Index';
import VesselView from '../views/settings/matrix/View';

import SIAccounts from '../views/settings/si-account/Index';
import SIAccountView from '../views/settings/si-account/View';

import CMSAccounts from '../views/settings/cms-account/Index';
import CMSAccountView from '../views/settings/cms-account/View';

import CrewViewTon from '../views/crewing/CrewViewTon';

Vue.use(VueRouter);

const routes = [

  {path: '/', name: 'Login', component: Login},

  {
    path: '/m',
    name: 'Main',
    component: Main,
    // redirect: '/m/dashboard',
    redirect: '/m/tons',
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: Dashboard,
      },

      {
        path : 'crewview-ton/:crewTonId',
        name :'CrewViewTon',
        component: CrewViewTon,
        meta: {
          requiresAuth: true,
        },
      },

      {
        path: 'tons',
        name: 'CrewTONS',
        component: CrewTONS,
        redirect: 'tons/index',
        children: [
          {path: 'index', name: 'CrewTonIndex', component: CrewTonIndex},
          {
            path: 'tons-view',
            name: 'CrewTonView',
            component: CrewTonView,
          },
        ],
      },

      {
        path: 'settings',
        name: 'Settings',
        component: Settings,
        redirect: '/settings/matrix',
        children:
            [
              /** matrix **/
              {path: 'vessels', name: 'Vessels', component: Vessel},
              {
                path: 'vessel-view/:vesselId',
                name: 'VesselView',
                component: VesselView,
                props: (route) => {
                  const vesselId = Number.parseInt(route.params.vesselId, 10);
                  if (Number.isNaN(vesselId)) {
                    return 0;
                  }
                  return {vesselId};
                },
              },

              /** si accounts **/
              {path: 'si-acc', name: 'SIAccounts', component: SIAccounts},

              {
                path: 'si-acc-view/:userId',
                name: 'SIAccountView',
                component: SIAccountView,
                props: (route) => {
                  const userId = Number.parseInt(route.params.userId, 10);
                  return {userId};
                },
              },

              /** cms accounts **/
              // {path: 'cms-acc', name: 'CMSAccounts', component: CMSAccounts},

            ],
      },

      {
        path: 'change-pass',
        name: 'ChangePassword',
        component: ChangePassword,
      },
    ],
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

// adding meta for the authenticated routes
router.beforeEach(function(to, from, next) {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (localStorage.getItem(APP_TONS.TOKEN) != null) {
      next();
      return;
    }
    next('/');
  } else {
    next();
  }
});

export default router;
